<template>
  <router-link
    v-if="href"
    :to="href"
    :class="[
      `btn btn-${variant}`,
      { 'btn-w-m': !size },
      { 'btn-xs': size === 'xs' },
      { 'btn-sm': size === 'sm' },
      { 'btn-lg': size === 'lg' },
      { 'btn-outline': typeof outline === 'string' },
      { 'btn-rounded': typeof rounded === 'string' },
      { 'btn-block': typeof block === 'string' }
    ]">
    <slot></slot>
  </router-link>

  <button
    v-else
    ref="ladda"
    :data-style="efx"
    :type="type"
    :class="[
      `btn btn-${variant}`,
      { 'btn-w-m': !size },
      { 'btn-xs': size === 'xs' },
      { 'btn-sm': size === 'sm' },
      { 'btn-lg': size === 'lg' },
      { 'btn-outline': typeof outline === 'string' },
      { 'btn-rounded': typeof rounded === 'string' },
      { 'btn-block': typeof block === 'string' }
    ]"
    @click="onClick">
    <slot></slot>
  </button>
</template>

<script>
import * as Ladda from 'ladda'
import 'ladda/css/ladda.scss'

export default {
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      default: 'default'
    },
    size: {
      type: String
    },
    outline: {
      type: String,
      default: null
    },
    rounded: {
      type: String,
      default: null
    },
    block: {
      type: String,
      default: null
    },
    href: {
      type: Object
    },
    efx: {
      type: String,
      default: 'zoom-in'
    },
    laddaControl: {
      type: Boolean
    }
  },
  watch: {
    laddaControl () {
      Ladda.create(this.$refs.ladda).toggle()
    }
  },
  methods: {
    onClick () {
      this.$emit('onClick', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/buttons/Buttons.vue